import { ja } from 'vuetify/locale';
import designerI18n from './designer-i18n.js';

export default {
    welcome: "ようこそ",
    login: "ログイン",
    logout: "ログアウト",
    about: "概要",
    dashboard: "ホーム",
    products: "商品",
    users: "ユーザー",
    labels: "ラベル",
    createUser: "ユーザーを作成",
    editUser: "ユーザーを編集",
    deleteUser: "ユーザーを削除",
    userList: "ユーザー一覧",
    productList: "商品一覧",
    createProduct: "商品を作成",
    editProduct: "商品を編集",
    deleteProduct: "商品を削除",
    labelSettings: "ラベル設定",
    createCategory: "カテゴリを作成",
    editCategory: "カテゴリを編集",
    deleteCategory: "カテゴリを削除",
    categoryList: "カテゴリ一覧",
    dragToReorder: "ドラッグしてカテゴリを並べ替え",
    name: "名前",
    nameFormat: "名前（名 姓）*",
    email: "メールアドレス",
    emailFormat: "メールアドレス*",
    role: "管理者",
    actions: "操作",
    save: "保存",
    cancel: "キャンセル",
    edit: "編集",
    delete: "削除",
    confirmDelete: "この項目を削除してもよろしいですか？",
    yes: "はい",
    no: "いいえ",
    search: "検索...",
    itemsPerPageText: "1ページあたりの件数:",
    pageText: "{0}-{1} / {2}",
    productName: "商品名*",
    productNumber: "商品番号",
    productOnList: "商品名",
    category: "カテゴリ",
    categoryOnList: "カテゴリ",
    categories: "カテゴリ",
    noCategories: "カテゴリがありません",
    thawingDays: "解凍（日）",
    notesHint: "この商品に関する追加情報",
    refridgeDays: "冷蔵（日）",
    threeHoursHint: "この商品は3時間常温で置けますか？",
    allergens: "アレルゲン",
    selectAllergens: "アレルゲンを選択",
    noAllergens: "アレルゲンなし",
    notes: "メモ",
    daysUntilExpiration: "賞味期限までの日数",
    daysNeededForThawing: "解凍に必要な日数",
    daysInRefrigeration: "冷蔵日数",
    producedDateLabel: "製造日",
    openedDateLabel: "開封日",
    createdAt: "作成日",
    updatedAt: "更新日",
    expirationDate: "賞味期限",
    openedDate: "開封日",
    producedDate: "製造日",     
    numLabels: "ラベル枚数",
    quantity: "数量",
    foodItems: "商品",
    printSelected: "選択項目を印刷",
    mandatoryField: "必須項目を示します",
    categoryName: "カテゴリ名*",
    description: "説明",
    descriptionHint: "Enterで改行",
    standardCategory: "既定のカテゴリ",
    fieldRequired: "必須項目です",
    standard: "既定",
    devices: "デバイス",
    deviceNick: "デバイスの表示名",
    deviceID: "デバイスID",
    confirmDeleteDevice: "次のデバイスを削除してもよろしいですか:",
    userAdministration: "ユーザー管理",
    newPasswordOptional: "新しいパスワード（任意）",
    passwordFormat: "パスワード*",
    password: "パスワード",
    admin: "管理者",
    printFooditems: "ラベルを印刷",
    fromFooditems: "食品から",
    loadingHomepage: "ホームページを読み込み中...",
    pleaseLogin: "ホームページにアクセスするにはログインしてください",
    settings: "設定",
    displaySettings: "表示設定",
    theme: "テーマ",
    light: "ライト",
    dark: "ダーク",
    language: "言語",  
    selectLanguage: "言語を選択",
    finnish: "フィンランド語",
    danish: "デンマーク語",
    english: "英語",
    swedish: "スウェーデン語",
    norweigian: "ノルウェー語",
    german: "ドイツ語",
    japaneese: "日本語",
    selectedLabel: "選択したラベル",
    dataManagement: "データ管理",
    importData: "データをインポート",
    exportData: "データをエクスポート",
    importExport: "インポート / エクスポート",
    exportProducts: "商品をエクスポート",
    importProducts: "商品をインポート",
    selectFile: "ファイルを選択",
    upload: "アップロード",
    download: "ダウンロード",
    dataImportSuccess: "データをインポートしました",
    dataImportError: "データのインポートでエラーが発生しました",
    importProductsSubtitle: "xlsxファイルから商品をインポートします。",
    useCategories: "カテゴリを表示",
    defaultLabel: "既定のラベル",
    defaultLabelHint: "ラベル印刷時にあらかじめ選択されるラベルを選びます。",
    noLabelsAvailable: "利用できるラベルがありません",
    copy: "コピー",
    useAliasAsTitle: "エイリアスをタイトルに使用",
    useAliasAsTitleHint: "「商品名」の代わりに「エイリアス」を使用します。エイリアスが空の場合は商品名を使用します。",
    menus: "メニュー",
    locations: "拠点",
    deleteSelected: "選択項目を削除",
    confirmDeleteSelected: "{count} 件の商品を削除してもよろしいですか？",
    create: "作成",
    createNewCategory: "新しいカテゴリを作成",
    nutritionProfile: "栄養プロファイル",
    nutritionProfileHint: "ラベルの栄養成分要素で使用されます。",
    noNutritionProfiles: "栄養プロファイルがまだありません",
    days: "日",
    hours: "時間",
    alias: "エイリアス",
    barcode: "バーコード",

    // Label Designer
    labelDesigner: "ラベルデザイナー",
    saveLabel: "ラベルを保存",
    refresh: "更新",
    selectLabel: "ラベルを選択",
    createNewLabel: "新しいラベルを作成",
    labelName: "ラベル名",
    width: "幅 (mm)",
    height: "高さ (mm)",
    titleFont: "タイトル文字サイズ (pt)",
    titleX: "タイトル X (mm)",
    titleY: "タイトル Y (mm)",
    active: "有効",
    addField: "フィールドを追加",
    fieldType: "フィールドの種類",
    labelText: "フィールドテキスト",
    baseDate: "基準日",
    offsetField: "オフセットフィールド",
    databaseField: "データベースフィールド",
    xPosition: "X座標 (mm)",
    yPosition: "Y座標 (mm)",
    fontSize: "文字サイズ (pt)",
    qrSize: "QRコードのサイズ (mm)",
    preview: "プレビュー",
    sampleItemName: "商品名のサンプル",
    size: "サイズ",
    scale: "倍率",
    fieldsCount: "フィールド",
    newLabel: "新しいラベル",
    newField: "新しいフィールド",
    labelSaved: "ラベルを保存しました！",
    loadLabelsFailed: "ラベルを読み込めませんでした",
    saveLabelFailed: "ラベルを保存できませんでした",
    labelPrinting: "ラベル印刷",
    productsPerPage: "1ページあたりの件数",
    showAll: "すべて表示",
    selectAtLeastOne: "少なくとも1件選択してください。",
    noLabelSelected: "ラベルが選択されていません。設定で選択してください。",
    labelColor: "ラベルの色",
    creditZplImage: "ZPL画像プラグイン開発者: ",
    fieldTypePrompt: "入力プロンプト",
    promptDialogTitle: "入力",

    // Label Type
    labelType: "ラベルの種類",
    labelTypeStandard: "既定",
    labelTypeFreetext: "フリーテキスト",
    freetextNotice: "フリーテキストラベルはタブレットで自由に入力できる空欄です。商品名や定義済みフィールドは表示されません。",

    // Logo
    logo: "ロゴ",
    logoReplace: "置き換え",
    logoUpload: "アップロード",
    logoRemove: "削除",
    logoNoLogo: "ロゴがアップロードされていません。ラベルに配置するには追加してください。",
    logoUploadTitle: "ロゴをアップロード",
    logoSelectFile: "PNG画像を選択",
    logoSelectFileHint: "印刷したい向きに回転させた状態でアップロードしてください。",
    logoWidthOnLabel: "ラベル上の幅 (mm)",
    logoWidthHint: "高さは自動的に計算されます",
    logoPrinterDpi: "プリンターのDPI",
    logoOriginal: "オリジナル",
    logoTarget: "目標",
    logoBlackThreshold: "黒しきい値",
    logoBlackThresholdHint: "低い＝暗いピクセルのみ黒に。高い＝明るいピクセルも黒になります。",
    logoPreviewOriginal: "オリジナル",
    logoPreviewMono: "モノクロ（印刷時）",
    logoApply: "適用",
    logoLoaded: "ロゴを読み込みました（{width}×{height}mm）。下のX/Yでラベル上に配置してください。",
    logoNotUploaded: "ロゴがまだアップロードされていません。ラベル設定 → ロゴ からアップロードしてください。",
    logoUploaded: "ロゴをアップロードして変換しました",
    logoUploadFailed: "ロゴをアップロードできませんでした",
    logoProcessFailed: "ロゴを処理できませんでした",
    logoInvalidDimensions: "寸法が無効です",
    logoNoFile: "ファイルが選択されていません",

    // Field Types (dropdown titles)
    fieldTypeDate: "日付",
    fieldTypeDatePlus: "日付 + 日数",
    fieldTypeDatabase: "データベースフィールド",
    fieldTypeQrcode: "QRコード",
    fieldTypeBarcode: "バーコード (Code128)",
    fieldTypeLogo: "ロゴ画像",
    fieldTypeValueOnly: "値のみ（フリー配置）",
    fieldTypeAllergensText: "アレルゲンテキスト",
    fieldTypeStatic: "固定テキスト",
    fieldTypeDivider: "区切り線",

    // Value Only sub-types
    valueType: "値の種類",
    valueTypeDate: "日付",
    valueTypeDatePlus: "日付 + 日数",
    valueTypeDatabase: "データベースフィールド",

    // Field position & size labels
    xMm: "X (mm)",
    yMm: "Y (mm)",
    rotation: "回転",

    // Separator & value position
    separator: "区切り文字",
    separatorHint: "ラベルと値の間のテキスト。区切りが不要な場合は空欄にしてください。",
    separatorPlaceholder: ": ",
    valueXMm: "値 X (mm)",
    valueXHint: "空欄にするとラベルの直後に配置されます",
    valueYMm: "値 Y (mm)",
    valueYHint: "空欄にするとラベルのY座標を使用します",
    valueFontSize: "値の文字サイズ",
    valueFontSizeHint: "空欄にするとラベルの文字サイズを使用します",

    // Font style
    bold: "太字",
    italic: "斜体",

    // Text alignment
    textAlignment: "文字の配置",
    alignLeft: "左",
    alignCenter: "中央",
    alignRight: "右",

    // QR Code
    qrDataSource: "QRデータソース",

    // Barcode
    barcodeDataSource: "データソース",
    barcodeWidthMm: "バーコードの幅 (mm)",
    barcodeHeightMm: "バーコードの高さ (mm)",
    barcodeDisplayValue: "バーコードの下に値を表示",

    // Allergens text
    allergenSeparator: "区切り文字",
    allergenSeparatorHint: "アレルゲン名の間の文字（例: ', ' や ' / '）",

    // Divider
    dividerLineWidth: "線の長さ (mm)",
    dividerLineWidthHint: "区切り線の長さ",
    dividerLineThickness: "線の太さ (mm)",
    dividerLineThicknessHint: "線の太さ",

    // Date Base
    
    // Database Fields
    fridgeValue: "冷蔵値",
    fridgeValueHint: "例: 開封前",
    threeHours: "3時間（はい/いいえ）",
    itemName: "商品名",
    
    // Offset Fields
    thawingDaysOffset: "解凍日数",
    refrigeratedDaysOffset: "冷蔵日数",
    expiryDays: "消費期限（日）",
    thawingHours: "解凍時間",
    refrigeratedHours: "冷蔵時間",
    expiryHours: "消費期限（時間）",
    showTime: "時刻を表示",
    
    // QR Data Fields
    itemId: "商品ID",
    customUrl: "カスタムURL",
    customData: "カスタムデータ",

    // Snackbar / status messages
    labelSavedSuccess: "ラベルを保存しました",
    labelSaveFailed: "ラベルを保存できませんでした",
    labelLoadFailed: "ラベルを読み込めませんでした",
    labelLoadSingleFailed: "ラベルを読み込めませんでした",
    fieldOrderUpdated: "フィールドの順序を更新しました",

    // Labels management view
    labelsDescription: "ラベルを管理します — 詳細の確認、有効/無効の切り替え、削除。",
    totalLabels: "ラベル合計",
    activeLabels: "有効なラベル",
    inactiveLabels: "無効なラベル",
    labelsList: "ラベル",
    searchLabels: "ラベルを検索...",
    dimensions: "寸法",
    inactive: "無効",
    color: "色",
    type: "種類",
    freetext: "フリーテキスト",
    viewLabel: "ラベルを表示",
    noLabelsFound: "ラベルが見つかりません",
    createFirstLabel: "最初のラベルを作成",
    namePosition: "名前の位置",
    fieldLabel: "フィールド名",
    position: "位置",
    noFields: "フィールドが設定されていません",
    hasLogo: "ロゴあり",
    status: "ステータス",
    editInDesigner: "デザイナーで編集",
    confirmDeleteText: "'{labelName}' を削除してもよろしいですか？この操作は取り消せません。",
    deleteWarning: "このラベルに属するすべてのフィールドも削除されます。",
    labelActivated: "'{name}' が有効になりました",
    labelDeactivated: "'{name}' が無効になりました",
    labelToggleError: "ラベルのステータスを変更できませんでした",
    labelDeleted: "'{name}' を削除しました",
    labelDeleteError: "ラベルを削除できませんでした",
    close: "閉じる",
    deleteLabel: "ラベルを削除",

    // device management
    devicesDescription: "デバイスとライセンスを管理します。",
    totalLicenses: "ライセンス合計",
    usedLicenses: "使用中のライセンス",
    availableLicenses: "利用可能なライセンス",
    devicesList: "デバイス",
    searchDevices: "デバイスを検索...",
    deleteDevice: "デバイスを削除",
    noDevicesFound: "デバイスが見つかりません",
    noDevicesHint: "デバイスはアプリから登録されます。",
    deleteDeviceHint: "使用するにはデバイスを再登録する必要があります。",
    deviceDeleted: "'{name}' を削除しました",
    deviceDeleteError: "デバイスを削除できませんでした",
    canEdit: "編集可",
    cannotEdit: "編集不可",
    canEditProducts: "編集",
    allowEditing: "編集を許可",
    disableEditing: "編集を無効化",
    editingEnabled: "編集を有効にしました",
    editingDisabled: "編集を無効にしました",
    selected: "選択済み",
    updateError: "更新に失敗しました",
    canDelete: "削除可",
    cannotDelete: "削除不可",
    canDeleteProducts: "削除",
    allowDeleting: "削除を許可",
    disableDeleting: "削除を無効化",
    deletingEnabled: "削除を有効にしました",
    deletingDisabled: "削除を無効にしました",
    editingDisabledCascade: "編集を無効にしました — 削除も無効になりました",
    deletingEnabledCascade: "削除を有効にしました — 編集も有効になりました",
    allowBackdating: "過去日付を許可",
    disallowBackdating: "過去日付を無効化",
    backdatingEnabled: "過去日付を有効にしました",
    backdatingDisabled: "過去日付を無効にしました",
    backdatingDisabledCascade: "過去日付を無効にしました — 編集も無効になりました",
    backdatingEnabledCascade: "過去日付を有効にしました — 編集も有効になりました",
    backdatingOff: "過去日付を無効にしました",
    backdatingOn: "過去日付を有効にしました",
    maxBackdateDays: "過去日付の最大日数",
    maxBackdateDaysHint: "製造日・開封日にさかのぼって選択できる日数を設定します。0で過去日付を無効にします。",

    // Configurations Page
    configurations: "設定",
    globalSettings: "全体設定",
    globalSettingsHint: "これらの設定はこのアカウントのすべてのタブレットに適用されます。保存するとバージョンが更新され、タブレットが新しい設定を取得します。",
    tabletFields: "タブレットのフィールド",
    tabletFieldConfig: "タブレットのフィールド設定",
    tabletFieldConfigHint: "タブレットで商品を作成・編集する際に表示するフィールドを設定します。",
    tabletFieldConfigInfo: "ドラッグして並べ替えます。非表示のフィールドはタブレットのダイアログに表示されません。必須項目は保存前に入力する必要があります。",
    freetextLabels: "フリーテキストラベル",
    freetextLabelsOverview: "フリーテキストラベル",
    freetextLabelsHint: "ローカルのタブレットラベルを含むすべてのフリーテキストラベル。ローカルラベルは作成したデバイスでのみ表示されます。",
    noFreetextLabels: "フリーテキストラベルが見つかりません。",
    reassignToDevice: "デバイスに割り当て",
    reassignHint: "このフリーテキストラベルを割り当てるデバイスを選択します。元のデバイスには表示されなくなります。",
    labelsSelected: "{count} 件のラベルを選択中",
    targetDevice: "割り当て先デバイス",
    markAsLocal: "ローカルとしてマーク",
    reassign: "割り当て",
    moveToDevice: "デバイスに移動",
    removeFromAll: "すべてのデバイスから削除",
    broadcastNewLabel: "新しいラベルを複数のデバイスに配信",
    broadcastNew: "新規作成",
    broadcast: "配信",
    freetextContent: "フリーテキストの内容",
    selectAll: "すべて選択",
    deselectAll: "すべての選択を解除",
    selectDevices: "デバイスを選択",
    broadcastDevices: "{count} 件に送信",
    devicesSelected: "{count} 台のデバイスを選択中",
    pushToDevices: "{count} 台のデバイスに送信",
    pushExistingHint: "既存のラベルを複数のデバイスに送信します。",
    activeBroadcasts: "有効な配信",
    broadcastsHint: "現在複数のデバイスに配信されているフリーテキストラベル。すべてのデバイスから手動で削除するか、単一のデバイスに割り当てるまで有効なままです。",
    noBroadcasts: "有効な配信はありません",
    valuesInDays: "日",
    valuesInHours: "時間",
    showAlias: "エイリアスを表示",
    showAliasHint: "タブレットのホーム画面で商品名の下に「エイリアス」を表示します。",
    showMenuTab: "メニュータブを表示",
    showMenuTabHint: "有効なメニューをタブレットのホーム画面にタブとして表示します",
    hideCategoryAll: "「すべて」カテゴリを非表示",
    hideCategoryAllHint: "タブレットのカテゴリメニューから「すべて」を非表示にします",

    // Global Settings Toggles
    useCategoriesHint: "タブレットにカテゴリメニューを表示し、商品作成時にカテゴリを選択できるようにします",
    usePrintDialog: "印刷ダイアログを表示",
    usePrintDialogHint: "タブレットでラベルを印刷する前に日付選択ダイアログを表示します",
    showTimestampOnDates: "日付に時刻を表示",
    showTimestampOnDatesHint: "日付ラベルにHH:MMのタイムスタンプを含めます（例: 17/02/26 10:30）",
    showCategoryOnProduct: "商品にカテゴリを表示",
    showCategoryOnProductHint: "タブレットのホーム画面で商品名の下にカテゴリ名を表示します",
    todaysDateInclusive: "当日を含める",
    todaysDateInclusiveHint: "賞味期限の計算に当日を含めます（例: 月曜から3日 = 木曜ではなく水曜）",
    settingsVersionInfo: "現在のバージョン",
    settingsVersionHint: "古いバージョンのタブレットは次回の更新時に新しい設定を取得します。",
    saveChanges: "変更を保存",

    // Field Config Table
    fieldName: "フィールド",
    customLabel: "カスタムラベル",
    visible: "表示",
    required: "必須",

    // Freetext Table
    content: "内容",
    device: "単位",
    scope: "範囲",
    updated: "更新日",
    local: "ローカル",
    global: "グローバル",
    confirmDeleteFreetext: "このフリーテキストラベルを削除してもよろしいですか？",
    freetextSizes: "利用可能なサイズ",
    freetextSizesHint: "利用可能なフリーテキストのサイズ一覧。",
    createSize: "サイズを作成",
    createFreetextSize: "フリーテキストのサイズを作成",
    widthMm: "幅 (mm)",
    heightMm: "高さ (mm)",
    freetextSizeWhiteHint: "フリーテキストラベルは白で表示されます",
    default: "既定",
    setAsDefault: "既定に設定",
    cancelDefault: "既定を解除",

    // Location management
    locationName: "拠点名",
    assignUser: "ユーザーを割り当て",
    assignedUsers: "割り当て済みユーザー",
    noUsersAssigned: "割り当てられたユーザーはいません",
    addUsers: "ユーザーを追加",
    selectUsers: "ユーザーを選択",
    assignProducts: "商品を割り当て",
    assignedProducts: "割り当て済み商品",
    availableProducts: "利用可能な商品",
    noProductsAssigned: "割り当てられた商品はありません",
    allProductsAssigned: "すべての商品を割り当て済み",
    countryCode: "国コード",
    timezone: "タイムゾーン",
    createdLocation: "拠点を作成しました",
    editLocation: "拠点を編集",
    totalLabelsPrinted: "印刷したラベルの合計",
    clickForBreakdown: "詳細な内訳を表示するにはクリック",
    printStatsTitle: "印刷統計",
    noPrintEvents: "拠点の印刷統計が見つかりません",
    labelsPrintedTotal: "枚のラベルを印刷（合計）",
    since: "以降",
    createLocation: "拠点を作成",

    //Tickets System
    createTicket: "チケットを作成",
    ticketType: "チケットの種類",
    ticketTypeSale: "営業",
    ticketTypeSupport: "サポート",
    ticketTypeBug: "バグ報告",
    ticketTitle: "タイトル",
    ticketDescriptionHint: "問題またはご依頼を詳しくご記入ください",
    ticketReporter: "報告者",
    ticketCreated: "チケットを作成しました",
    priority: "優先度",
    priorityHint: "空欄にするとチケットの内容から自動判定されます。手動で選択することもできます",
    priorityAuto: "自動",
    priorityLow: "低",
    priorityMedium: "中",
    priorityHigh: "高",
    priorityUrgent: "緊急",
    submit: "チケットを送信",
    tickets: "チケット",
    orderAccessories: "ラベル・付属品を注文",
    ticketLogHint: "Capture IT に送信されたサポート依頼の一覧。",

    impersonation: {
        menuItem: "顧客アカウントに入る",
        title: "顧客アカウントに入る",
        subtitle: "顧客を選択してそのアカウント内で作業します。すべての操作は実際のデータに反映されます。",
        search: "顧客名、口座番号、メールアドレスで検索...",
        customer: "顧客",
        lastPrint: "最終印刷",
        enter: "入る",
        noCustomers: "顧客が見つかりません",
        loadFailed: "顧客リストを読み込めませんでした",
        confirmTitle: "この顧客のアカウントに入りますか？",
        confirmText: "{customer} のアカウントを、その管理者の権限で開こうとしています。",
        confirmWarning: "すべての操作は顧客の実際のデータに反映されます。このセッションは記録され、2時間後に自動的に終了します。",
        bannerTitle: "{customer} のアカウント内で作業しています",
        bannerSubtitle: "背後では本人（{user}）としてログイン中",
        stop: "終了",
        actions: "操作",
    }, 

    designer: {
        untitled: "無題",
        noLabel: "ラベルが選択されていません",
        saved: "保存しました",
        saveError: "保存できませんでした",
        unsavedTitle: "未保存の変更",
        unsavedConfirm: "未保存の変更があります。ページを離れますか？",
        leaveAnyway: "それでも離れる",
        stay: "とどまる",
        toggleGrid: "グリッドの切り替え",
        preview: "プレビュー",
        undo: "元に戻す",
        redo: "やり直す",
        save: "保存",
        print: "印刷",
        back: "戻る",
    },
    fields: {
        productFields: "商品フィールド",
        productField: "商品フィールド",
        barcodes: "バーコード",
        layout: "レイアウト",
        qrCode: "QRコード",
        staticText: "固定テキスト",
        imageLogo: "ロゴ画像",
        divider: "区切り線",
        productNumber: "商品番号",
        productName: "商品名",
        description: "説明",
        costPrice: "原価",
        salesPrice: "販売価格",
        currency: "通貨",
    },
    common: {
        none: "なし",
        save: "保存",
        cancel: "キャンセル",
        delete: "削除",
        close: "閉じる",
        edit: "編集",
        copy: "コピー",
        unsaved: "未保存の変更",
        loading: "読み込み中...",
        error: "エラー",
        success: "成功",
    },
    label: {
        name: "ラベル名",
        width: "幅 (mm)",
        height: "高さ (mm)",
        color: "色",
        colour: "色",
        type: "種類",
        grid: "グリッド",
        gridSize: "グリッドサイズ (mm)",
        active: "有効",
        unit: "単位",
        mm: "mm",
        inch: "インチ",
    },
    canvas: {
        grid: "グリッドを表示",
        gridSize: "グリッドサイズ (mm)",
        layers: "レイヤー",
        noElements: "要素がありません",
    },
    importFromOld: "旧システムからインポート",
    selectLabelsToImport: "インポートするラベルを選択",
    importHint: "ラベルは新システムにインポートされます。元のラベルは残ります。",
    importCount: "{n} 件のラベルをインポート",
    newDesign: "新しいラベル",
    designs: "ラベル",
    searchDesigns: "ラベルを検索...",
    totalDesigns: "ラベル合計",
    activeDesigns: "有効なラベル",
    inactiveDesigns: "無効なラベル",
    designCreated: "ラベルを作成しました",
    designCopied: "ラベルをコピーしました",
    designDeleted: "ラベルを削除しました",
    designsDeleted: "ラベルを削除しました",
    deleteDesign: "ラベルを削除",
    deleteDesignConfirm: "'{name}' を削除してもよろしいですか？",
    bulkDelete: "選択項目を削除",
    bulkDeleteConfirm: "{n} 件のラベルを削除してもよろしいですか？",
    errorCreating: "ラベルを作成できませんでした",
    errorUpdating: "ラベルを更新できませんでした",
    errorCopying: "ラベルをコピーできませんでした",
    errorDeleting: "ラベルを削除できませんでした",
    errorLoading: "ラベルを読み込めませんでした",
    importSuccess: "{n} 件のラベルをインポートしました",
    importError: "インポートエラー",
    labelsSubtitle: "ラベルを管理",
    roundExpiryDownToQuarter: "賞味期限の時刻を15分単位で切り下げる",
    roundExpiryDownToQuarterHint: "消費期限が時間単位の場合のみ。16:07 の期限は 16:00 と表示されます — 常に切り下げるため、消費期限を超えることはありません",
    // Shown on the colour swatch in the product list when the
    // product prints with something other than its own label.
    labelInactiveFallback: "ラベル「{label}」は無効です — 「{fallback}」で印刷されます",
    labelMissingFallback: "ラベルが選択されていません — 「{fallback}」で印刷されます",

    // Bulk deletion of categories, including the "these still
    // contain products — move them where?" second step.
    confirmBulkDeleteCategories: "選択したカテゴリを削除しますか？",
    bulkDeleteWarning: "この操作は取り消せません。",
    categoriesInUseTitle: "カテゴリは使用中です",
    categoriesInUseText: "次のカテゴリにはまだ商品が含まれています:",
    moveProductsTo: "商品の移動先",
    moveAndDelete: "移動して削除",
    noReassignTarget: "すべてのカテゴリが選択されています。商品の移動先として少なくとも1つの選択を解除してください。",
    categoriesDeleted: "件のカテゴリを削除しました",
    productsMoved: "件の商品を移動しました",
    defaultCategorySkipped: "既定のカテゴリはスキップされました",
    bulkDeleteFailed: "削除に失敗しました",

    totalLocations: "拠点の合計",

    productImage: "商品画像",
    chooseFromLibrary: "ライブラリから選択",
    changeImage: "画像を変更",
    productImageHint: "画像表示が有効な場合、タブレットで商品名の代わりに表示されます",
    productImageLibrary: "画像ライブラリ",

    productImages: {
        libraryTitle: "画像ライブラリ",
        libraryHint: "商品画像をまとめてアップロードし、後から商品に割り当てます。",
        uploadButton: "画像をアップロード",
        deleteSelected: "選択した項目を削除",
        uploadProgress: "アップロード中",
        alreadyInLibrary: "すでにライブラリにあります",
        noImages: "画像がまだありません",
        preview: "プレビュー",
        name: "名前",
        dimensions: "サイズ",
        usedBy: "使用中の商品数",
        uploaded: "アップロード済み",
        uploadSummary: "{n} 点の画像をアップロードしました",
        uploadSummaryFailed: "{n} 点をアップロードしました。{failed} 点は失敗しました",
        uploadSummaryDuplicates: "{n} 点をアップロードしました。{duplicates} 点は重複のためスキップしました",
        imageRenamed: "画像の名前を変更しました",
        renameFailed: "画像の名前を変更できませんでした",
        confirmDeleteImage: "この画像を削除してもよろしいですか？",
        deleteImageInUseWarning: "{n} 件の商品がこの画像を使用しており、画像が失われます。",
        imageDeleted: "画像を削除しました",
        imageDeletedInUse: "画像を削除しました。使用していた商品には画像がなくなりました",
        deleteFailed: "画像を削除できませんでした",
        confirmBulkDelete: "削除の確認",
        confirmBulkDeleteText: "{n} 点の画像を削除してもよろしいですか？",
        selectedInUseWarning: "選択した画像のうち {n} 点が使用中で、使用している商品から失われます。",
        andMoreCount: "… 他 {n} 点",
        deleteAll: "すべて削除",
        imagesDeletedSummary: "{n} 点の画像を削除しました",
        imagesDeletedMissing: "{n} 点の画像を削除しました（{missing} 点は見つかりませんでした）",
        bulkDeleteFailed: "画像を削除できませんでした",

        picker: {
            title: "画像を選択",
            uploadNew: "新規アップロード",
            search: "画像を検索...",
            empty: "ライブラリに画像がまだありません。アップロードして始めてください。",
            noMatch: "検索に一致する画像がありません",
            removeImage: "画像を削除",
            uploadFailedCount: "{n} 点の画像をアップロードできませんでした",
        },
    },
    showProductImages: "商品画像を表示",
    showProductImagesHint: "タブレットのホーム画面に商品画像を表示します。",
    showProductNames: "商品名を表示",
    showProductNamesHint: "タブレットのホーム画面に商品名を表示します。",

    productDisplayMode: "商品の表示",
    displayModeText: "名前",
    displayModeImage: "画像",
    displayModeUser: "ユーザーの選択",
    mixed: "混在",
    noDevicesUpdated: "更新されたデバイスはありません",
    customFields: "カスタムフィールド",
    customFieldsHint: "特定の商品情報を表示するフィールドを追加します",
    noCustomFields: "カスタムフィールドがありません",
    editField: "フィールドを編集",
    fieldLabelHint: "フィールドのラベル",
    fieldPrefixHint: "フィールドの接頭辞",
    fieldKeyFixedHint: "フィールドのキー（変更不可）",
    deleteFields: "フィールドを削除",
    deleteFieldsWarning: "選択したフィールドを完全に削除します",
    deactivateInsteadHint: "削除する代わりに無効化します",
    fieldsDeleted: "フィールドを削除しました",
    valuesRemoved: "値を削除しました",
    storedValues: "保存された値",
    printedPrefix: "印刷される接頭辞",
    prefix: "接頭辞",
    fieldKey: "フィールドキー",
    values: "値",
    sortOrder: "並び順",
    labelRequired: "ラベルは必須です",

    ...designerI18n.ja,
}